import React from 'react';
import { Icon } from '@tcc/crate';

const WarningIcon = () => (
  <Icon className="vra-warning-icon" testId="vra-warning-icon" glyph={Icon.set.WARNING} />
);
export default WarningIcon;
